// extracted by mini-css-extract-plugin
export default {"miner":"Shop_miner__EarDM","container":"Shop_container__ODhy-","footer":"Shop_footer__Kkxjj"};